var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"json-display"},[(_vm.expanded)?_c('span',{attrs:{"title":"collapse"},on:{"click":function($event){_vm.expanded = false}}},[_vm._v(" "+_vm._s(_vm.full)+" ")]):_c('span',{attrs:{"title":"expand"},on:{"click":function($event){_vm.expanded = true}}},[_vm._v(" "+_vm._s(_vm.summary)+" ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-316cf5e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/JSONDisplay.vue
// module id = null
// module chunks = 